import { disabledCoins } from '../../cred';

export const initialDisabledThingies = {
	with: [],
	depo: [],
	trade: [],
};

const getDisabledThingies = async state => {
	const { disabledThingies } = state;

	try {
		const { status, data } = await disabledCoins();

		if (status === 1) {
			return {
				disabledThingies: Object.assign({}, disabledThingies, data),
			};
		}
	} catch (error) {
		console.log('disabledThingies', error);
	}
	return {};
};

// ---------------------------------------------------------

export const disabledThingiesActions = {
	__getDisabledThingies: getDisabledThingies,
};
